import { FC, useState } from 'react'
import { MdPhoneAndroid } from 'react-icons/md'
import { enqueueSnackbar } from 'notistack'
import NUIAlert from '@/components/Alert/Alert'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { webApiService } from '@/services'
import StepCard from './StepCard'
import { useTradeinContext } from '../hooks/useTradeinContext'

/** Paso de prueba (nuevo layout): el IMEI detectado no es válido, se pide ingresarlo a mano. */
const ImeiCorrection: FC = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const [loading, setLoading] = useState(false)

  const handleSave = () => {
    setLoading(true)
    // was_imei_corrected = 1: el back marca que el IMEI fue corregido manualmente.
    webApiService.update({ stage: 7, id: ctx.tradein.id, serie: ctx.serie, id_seller: ctx.tradein.id_seller, was_imei_corrected: 1 })
      .then(() => {
        enqueueSnackbar('Se actualizó el número de IMEI/serie.', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el número de IMEI/serie.', { variant: 'error' })
        console.log('error ==>', error)
      })
      .finally(() => {
        saveCtx({ ...ctx, reload: true })
        setLoading(false)
      })
  }

  return (
    <StepCard
      icon={<MdPhoneAndroid />}
      title='Validar IMEI'
      subtitle='El IMEI detectado no es válido'
    >
      <NUIAlert type='warning'>Por favor ingresa el IMEI manualmente, el IMEI detectado no es válido.</NUIAlert>
      <div className='flex flex-col gap-1.5 my-4'>
        <label className='text-xs uppercase tracking-widest text-slate-500'>IMEI</label>
        <div className='flex items-center gap-3'>
          <Input value={ctx.serie} onChange={(e) => saveCtx({ ...ctx, serie: e.target.value })} placeholder='Agregar IMEI' />
          <Button disabled={loading} onClick={handleSave}>
            {loading ? 'Guardando...' : 'Guardar'}
          </Button>
        </div>
      </div>
      <NUIAlert type='info'>
        Asegúrate de que el número de serie/IMEI sea correcto, ya que no podrás modificarlo una vez guardado.
      </NUIAlert>
    </StepCard>
  )
}

export default ImeiCorrection
